import reference from '../data/pricebook-part-reference.json';

type CatalogIdentity = { id: string; name: string; sku?: string | null };
const normalize = (value: string) => value.trim().replace(/\s+/g, ' ').toLowerCase();
const byId = new Map(reference.map(row => [`st-price_book_item-${row.sourceId}`, row]));

export function pricebookPartReference(item: CatalogIdentity) {
 const source = byId.get(item.id);
 return source && source.sourceId === item.sku && normalize(source.name) === normalize(item.name) ? source : null;
}

export function pricebookPartNumber(item: CatalogIdentity) {
 return pricebookPartReference(item)?.partNumber || item.sku || null;
}

export function pricebookPartSearchText(item: CatalogIdentity) {
 const source = pricebookPartReference(item);
 return [item.sku, source?.partNumber, ...(source?.vendors.map(vendor => `${vendor.name} ${vendor.partNumber}`) ?? [])].filter(Boolean).join(' ');
}
